export default (object, path = [], defaultReturn = undefined) => {
  let currentPathItem;
  let treePointer = object;
  for (let i = 0; i < path.length; i++) {
    currentPathItem = path[i];
    if (treePointer && treePointer[currentPathItem] !== undefined) {
      treePointer = treePointer[currentPathItem];
    } else {
      return defaultReturn;
    }
  }
  return treePointer;
};



// WEBPACK FOOTER //
// ./src/utils/get.js